import React from 'react';
import { Button, Icon, Tooltip } from '@pwc/pwc-deals-ui';
import { Box } from '@mui/material';

const DeleteButton = ({
  iconType,
  handleClick,
  handleMouseEnter,
  handleMouseLeave,
  tooltipPlacement,
  tooltip,
}) => {
  const className = iconType.includes('-theme')
    ? iconType
    : `${iconType} icon-orange-theme`;

  const handleOnMouseDown = (event) => {
    if (event.button === 0) {
      handleClick(event);
    }
  };

  return (
    <Tooltip direction={tooltipPlacement} tip={tooltip}>
      <Box
        display="flex"
        sx={{
          '& .ui-button': {
            mt: '-2px',
          },
        }}
      >
        <Button
          className="button-no-underline"
          onMouseDown={handleOnMouseDown}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          data-testid="remove-section"
          tabIndex={0}
        >
          <Icon name="bin" className={className} width={20} height={20} />
        </Button>
      </Box>
    </Tooltip>
  );
};

export default DeleteButton;
